import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/package'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(packet, uuid) {
    return http.put(`${resource}/${uuid}`, packet)
  },
  add(packet) {
    return http.post(`${resource}`, packet)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
